import styled from 'styled-components';

// Modal overlay - floating widget container
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000; /* Higher than search component (9999) */
  pointer-events: none; /* Allow clicking through to page content */
  overflow: visible; /* Allow visual connection elements to extend outside */
  
  /* No backdrop - users can interact with page while chatting */
`;

// Main modal container with responsive positioning
export const ModalContainer = styled.div`
  background: #121724; /* Dark theme background - should be dynamic */
  color: #ffffff;
  overflow: hidden; /* Clip content to rounded corners */
  display: flex;
  flex-direction: column;
  pointer-events: auto; /* Re-enable interactions for the widget itself */
  
  /* Desktop: dropdown from top-right */
  @media (min-width: 768px) {
    position: fixed;
    top: 120px; /* Optimal distance - close but not touching */
    right: 24px; /* Aligned with button area */
    width: 70vw; /* More compact - reduced from 90vw */
    max-width: 450px; /* Narrower max width - reduced from 600px */
    height: 500px;
    border-radius: 16px;
    box-shadow: 
      0 24px 48px rgba(0, 0, 0, 0.3), 
      0 0 0 1px rgba(255, 255, 255, 0.05),
      0 0 20px rgba(136, 80, 255, 0.4),
      0 0 40px rgba(136, 80, 255, 0.2);
    border: 1px solid #2a2f42;
    transform-origin: top right;
    animation: slideDown 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    z-index: 10000; /* Higher than search component (9999) */
    
    /* Ultra-minimal - let the button glow and positioning do the work */
  }
  
  /* Smooth dropdown animation */
  @keyframes slideDown {
    0% {
      opacity: 0;
      transform: translateY(-10px) scale(0.95);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  /* Mobile: full-screen modal */
  @media (max-width: 767px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    max-height: 100vh; /* Ensure no overflow */
    border-radius: 0;
    z-index: 10000; /* Higher than search component (9999) */
    overflow: hidden; /* Prevent any scrolling */
  }
`;

// Modal header with title and close button
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #2a2f42;
  min-height: 60px;
  background: #121724;
  border-radius: 16px 16px 0 0; /* Match container's top corners */
  flex-shrink: 0; /* Don't shrink on mobile */
  
  /* Mobile: larger padding and proper fitting */
  @media (max-width: 767px) {
    padding: 20px;
    min-height: 70px;
    border-radius: 0; /* No rounded corners on mobile */
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #9EA4B8;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #262B3D;
    color: #ffffff;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  /* Focus styles for accessibility */
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(136, 80, 255, 0.4);
  }
  
  /* Mobile: larger touch target */
  @media (max-width: 767px) {
    width: 44px;
    height: 44px;
  }
`;

// Content area that contains the WebRTC component
export const ModalContent = styled.div`
  flex: 1;
  overflow: hidden;
  border-radius: 0 0 16px 16px; /* Match container's bottom corners */
  
  /* Ensure the WebRTC component fills the available space */
  > * {
    width: 100%;
    height: 100%;
    border-radius: 0 0 16px 16px; /* Apply to child content too */
  }
  
  /* Mobile: ensure proper fit without scroll */
  @media (max-width: 767px) {
    border-radius: 0;
    min-height: 0; /* Allow flex shrinking */
    
    > * {
      border-radius: 0;
      max-height: 100%;
      overflow: hidden;
    }
  }
`;